<template>
    <div style="background: #EFEFEF; width: 100%; height: 100vh;position: absolute;">

        <v-layout justify-center row>
            <v-flex xs12 sm6>
                <v-card width="500" flat class="cardss">
                            <v-card-text class="text-center orange white--text pa-5">
                                <h3>
                                    Main Panel
                                </h3>
                                <v-btn block class="custom" x-small text @click="cerrarSesion()">
                                    Log Out
                                </v-btn>
                            </v-card-text>
                            <v-card-text>
                                <v-form @submit.prevent="uploadFiles()">
                                    <v-layout justify-center row>
                                        <v-flex xs12>
                                            <label>
                                                <span class="black--text">
                                                <strong>Product name</strong> 
                                                </span>  <br>
                                                <input v-model="name" type="text" class="inputTxt">
                                            </label>
                                        </v-flex>
                                        <div class="mx-2"></div>
                                        <v-flex xs12>
                                            <label>
                                                <span class="black--text">
                                                <strong>$$ Price</strong> 
                                                </span>  <br>
                                                <input v-model="price" type="text" class="inputTxt">
                                            </label>
                                        </v-flex>
                                        <v-flex xs12> 
                                            <label>
                                                <span class="black--text">
                                                <strong>Description</strong> 
                                                </span>  <br>
                                                <textarea v-model="description" rows="15" class="inputTxt"></textarea>
                                            </label>
                                        </v-flex>
                                        <div class="mx-2"></div>
                                        <v-flex xs12>
                                            <label> 
                                                <span class="black--text">
                                                <strong>Avalible</strong> 
                                                </span>  <br>
                                                <input v-model="avalible" type="text" class="inputTxt">
                                            </label>
                                        </v-flex>
                                        <v-flex xs12>
                                            <label> 
                                                <span class="black--text">
                                                <strong>Product File</strong> 
                                                </span>  <br>
                                                <input type="file" ref="boton" class="d-none" @change="buscarImagen($event)">
                                                <v-btn color="orange" style="width:100%;height:50px;" outlined @click="$refs.boton.click()">
                                                    <v-icon style="font-size: 14px;">
                                                        fas fa-file-upload
                                                    </v-icon>
                                                </v-btn>
                                                <br>
                                                Select a product
                                            </label> 
                                        </v-flex>
                                        <img class="my-2 mx-2" 
                                        width="100" height="100" 
                                        :src="this.urlTemporal" v-if="this.urlTemporal != null">
                                        <v-flex xs12 class="my-2">
                                            <v-switch
                                            v-model="switch1"
                                            color="orange"
                                            :label="`Coming Soon?: ${switch1.toString()}`"
                                            ></v-switch>
                                            <v-btn color="blue" class="white--text"
                                            type="submit">Upload Product</v-btn> 
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-card-text>
                        </v-card>
            </v-flex>
            <v-flex xs12 sm6>
               <topProducts/> 
            </v-flex>
        </v-layout>
    </div>
</template>

<style>
    .custom {
        text-transform: none;
    }
    .inputTxt {
    background-color: #fff;
    height: 31px;
    padding: 3px 7px;
    line-height: normal;
    color: #333;
    border: solid #a6a6a6 1px;
    border-top-color: #949494;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
    outline: 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.inputTxt:focus {
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
}
    .cardss {
        border-radius: 0%;
        margin: 50px auto;
        display: block;
    }
</style>

<script>
import topProducts from '../components/Products/topProducts'
import { mapState, mapActions, mapMutations } from "vuex";
import router from '../router'
var firebase = require('firebase/app')
import db from '../main'
import storage from '../main'
export default {

    components:{
        topProducts
    },
    
    data() {
        return {
            descriptionArr: [],switch1: true,file: null, urlTemporal: null, name: '', price: '', description: '', avalible: '', email: '', password: ''
        }
    },
    methods:{
        buscarImagen(event){
      console.log(event.target.files[0]);

      this.file = event.target.files[0]
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (e) => {
        this.urlTemporal = e.target.result
      }
    },
    async uploadFiles(){

        if (this.name === '' || this.price === '' || this.description === '' || this.avalible === '') {
            alert('Please fill in all fields')
        } else if (this.name != '' || this.price != '' || this.description != '' || this.avalible != ''){

            try {

        const djhfd = firebase.storage();

        const refImagen = djhfd.ref().child('Pipe Me In: Product' + this.file.name)

        const res = await refImagen.put(this.file) 

        console.log(res);

        const urlDescarga = await refImagen.getDownloadURL()

        await db.collection('products').add({
          name:        this.name,
          price:       this.price,
          description: this.description,
          avalible:    this.avalible,
          image:       urlDescarga,
          iscoming:    this.switch1,
          rating:      5
        })

        this.file = null
        
      } catch (error) {
        console.log(error);
      } finally {
          location.reload();
       }

        }

    },
        ...mapActions(['cerrarSesion'])
    },
    computed: {
        ...mapState(['usuario'])
    }
}
</script>